{
  "cameraCard": {
    "text": "接続中",
    "text2": "未接続",
    "text3": "Viewer画面へ",
    "label": "カメラ設定",
    "label2": "録画履歴"
  },
  "cameraFilterBar": {
    "label": "すべて",
    "label2": "接続中",
    "label3": "未接続",
    "placeholder": "カメラ名・エリア名・タグで検索",
    "button": "フィルタ",
    "label4": "接続状況",
    "label5": "カメラタイプ",
    "label6": "エリア",
    "label7": "タグ",
    "placeholder2": "タグを選択"
  },
  "cameraGrid": {
    "text": "条件に該当するカメラは",
    "text2": "見つかりませんでした"
  },
  "cameraGridHeader": {
    "text": "件"
  },
  "cameraSettingsDialog": {
    "enqueueSnackbar": "タグは{{MAX_CAMERA_TAGS}}つまで設定できます",
    "enqueueSnackbar2": "タグを更新しました",
    "enqueueSnackbar3": "タグの更新に失敗しました",
    "text": "更新中...",
    "title": "カメラ設定",
    "label": "デバイス名",
    "label2": "エリア",
    "label3": "デバイスID",
    "label4": "シリアルナンバー",
    "label5": "管理番号",
    "label6": "メモ",
    "label7": "タグ",
    "placeholder": "タグを選択",
    "text2": "タグは",
    "text3": "つまで設定できます（現在"
  },
  "useStreamViewState": {
    "label": "すべて"
  },
  "stream": {
    "title": "映像一覧"
  },
  "streamViewModeToggle": {
    "ariaLabel": "グリッド表示（大）",
    "ariaLabel2": "グリッド表示（小）",
    "ariaLabel3": "マップ表示"
  },
  "cameraActionPopover": {
    "ariaLabel": "メニューを閉じる",
    "text": "Viewer画面を開く",
    "text2": "カメラ設定"
  },
  "mapSelectBar": {
    "ariaLabel": "マップを選択",
    "text": "台",
    "text2": "マップ"
  },
  "streamMapView": {
    "text": "マップを取得できませんでした",
    "text2": "マップを開けませんでした",
    "alt": "{{name}} の図面",
    "text3": "マップがありません",
    "text4": "マップが登録されると、ここに表示されます"
  }
}
